/* Split Essential Cart's total savings without extra product or cart requests. */
(() => {
  'use strict';
  const selector = name => `[data-essential-cart-element="${name}"]`;
  let queued = false;
  const style = document.createElement('style');
  style.textContent = `
    [data-soothee-savings-ready] ${selector('discount-code-amount')} { display:none!important; }
    .soothee-cart-savings { display:grid; gap:6px; margin-top:10px; font-size:14px; line-height:1.4; color:#303030; }
    .soothee-cart-savings-row { display:flex; justify-content:space-between; gap:12px; }
    .soothee-cart-savings-row span:last-child { white-space:nowrap; font-variant-numeric:tabular-nums; }
  `;
  document.head.appendChild(style);

  function parseMoney(text) {
    const clean = text.replace(/[^0-9.,]/g, '');
    if (!clean) return NaN;
    const decimal = clean.match(/[.,](\d{2})$/);
    return decimal
      ? Number(clean.slice(0, -3).replace(/[.,]/g, '')) * 100 + Number(decimal[1])
      : Number(clean.replace(/[.,]/g, '')) * 100;
  }

  function render() {
    queued = false;
    const wrapper = document.querySelector(selector('discount-code-wrapper'));
    if (!wrapper) return;
    const cart = window.essentialCartApi?.getCartData?.();
    const amount = wrapper.querySelector(selector('discount-code-amount-value'));
    const old = wrapper.querySelector('.soothee-cart-savings');
    const total = amount ? parseMoney(amount.textContent) : NaN;
    if (!cart?.item_count || !Number.isFinite(total) || total < cart.total_discount) {
      old?.remove();
      wrapper.removeAttribute('data-soothee-savings-ready');
      return;
    }
    const discounts = new Map();
    function addDiscount(application, cents) {
      if (!application?.title || !(cents > 0)) return;
      const key = application.title.toUpperCase();
      const existing = discounts.get(key);
      discounts.set(key, [existing?.[0] || application.title, (existing?.[1] || 0) + cents]);
    }
    for (const item of cart.items || []) {
      for (const allocation of item.line_level_discount_allocations || []) {
        addDiscount(allocation.discount_application, allocation.amount);
      }
    }
    for (const application of cart.cart_level_discount_applications || []) {
      addDiscount(
        application.title ? application : application.discount_application,
        application.total_allocated_amount ?? application.discount_application?.total_allocated_amount ?? application.amount
      );
    }
    const rows = [];
    const productSavings = total - cart.total_discount;
    if (productSavings > 0) rows.push(['Product savings', productSavings]);
    rows.push(...discounts.values());
    const signature = JSON.stringify([cart.currency, rows]);
    if (old?.dataset.signature === signature) return;
    const block = document.createElement('div');
    block.className = 'soothee-cart-savings';
    block.dataset.signature = signature;
    block.setAttribute('aria-label', 'Savings breakdown');
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: cart.currency || 'USD'
    });
    for (const [label, cents] of rows) {
      const row = document.createElement('div');
      row.className = 'soothee-cart-savings-row';
      const name = document.createElement('span');
      name.textContent = label;
      const value = document.createElement('span');
      value.textContent = '−' + money.format(cents / 100);
      row.append(name, value);
      block.appendChild(row);
    }
    if (old) old.replaceWith(block); else wrapper.appendChild(block);
    wrapper.setAttribute('data-soothee-savings-ready', '');
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(render);
  }
  document.addEventListener('essential-cart:update', schedule);
  document.addEventListener('essential-cart:open', schedule);
  // The app renders its amount after fetching compare-at prices, after the cart event.
  new MutationObserver(records => {
    if (records.some(record => {
      const element = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      return !element?.closest('.soothee-cart-savings') && (
        element?.closest('#essential-cart-drawer-portal') ||
        [...record.addedNodes].some(node => node.nodeType === 1 && (node.id === 'essential-cart-drawer-portal' || node.querySelector?.('#essential-cart-drawer-portal')))
      );
    })) schedule();
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  schedule();
})();
